import {
  pi_bix_six_translated_titles,
  pi_team_roles_translated_titles,
  pi_trait_translated_titles,
  TranslationContent,
} from '@app/app/page-modules/personality-indicator/pi-questions/models/pi-questions.model';
import {
  spectrumTraitsAr,
  tmiTypeGroupsAr,
  tmiTypesReportAr,
} from '@app/app/page-modules/personality-indicator/pi-questions/pi-report/report-constants-ar';
import {
  spectrumTraitsCy,
  tmiTypeGroupsCy,
  tmiTypesReportCy,
} from '@app/app/page-modules/personality-indicator/pi-questions/pi-report/report-constants-cy';
import {
  spectrumTraitsDe,
  tmiTypeGroupsDe,
  tmiTypesReportDe,
} from '@app/app/page-modules/personality-indicator/pi-questions/pi-report/report-constants-de';
import {
  spectrumTraits,
  tmiTypeGroups,
  tmiTypesReport,
} from '@app/app/page-modules/personality-indicator/pi-questions/pi-report/report-constants-en';
import {
  spectrumTraitsFr,
  tmiTypeGroupsFr,
  tmiTypesReportFr,
} from '@app/app/page-modules/personality-indicator/pi-questions/pi-report/report-constants-fr';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';

export function getTmiTypesReport() {
  const language = LanguageCodeHelper.getCurrentLanguage();

  if (language === 'ar') {
    return tmiTypesReportAr;
  }

  if (language === 'fr') {
    return tmiTypesReportFr;
  }

  if (language === 'de') {
    return tmiTypesReportDe;
  }

  if (language === 'cy') {
    return tmiTypesReportCy;
  }

  return tmiTypesReport;
}

export function getTmiTypeGroups() {
  const language = LanguageCodeHelper.getCurrentLanguage();

  if (language === 'ar') {
    return tmiTypeGroupsAr;
  }

  if (language === 'fr') {
    return tmiTypeGroupsFr;
  }

  if (language === 'de') {
    return tmiTypeGroupsDe;
  }

  if (language === 'cy') {
    return tmiTypeGroupsCy;
  }

  return tmiTypeGroups;
}

export function getSpectrumTraits() {
  const language = LanguageCodeHelper.getCurrentLanguage();

  if (language === 'ar') {
    return spectrumTraitsAr;
  }

  if (language === 'fr') {
    return spectrumTraitsFr;
  }

  if (language === 'de') {
    return spectrumTraitsDe;
  }

  if (language === 'cy') {
    return spectrumTraitsCy;
  }

  return spectrumTraits;
}

export function getPiTraitScoreName(key: string): string {
  const language = LanguageCodeHelper.getCurrentLanguage();
  const titles = pi_trait_translated_titles[key];

  if (!titles) {
    return key.replace(/_/g, ' ');
  }

  const validLanguage = Object.keys(titles.title).includes(language) ? language : 'en';
  return titles.title[validLanguage as keyof TranslationContent] ?? key.replace(/_/g, ' ');
}

export function getPiTeamRolesName(key: string): string {
  const language = LanguageCodeHelper.getCurrentLanguage();
  const titles = pi_team_roles_translated_titles[key];

  if (!titles) {
    return key.replace(/_/g, ' ');
  }

  const validLanguage = Object.keys(titles.title).includes(language) ? language : 'en';
  return titles.title[validLanguage as keyof TranslationContent] ?? key.replace(/_/g, ' ');
}

export function getBixSixRolesName(key: string): string {
  const language = LanguageCodeHelper.getCurrentLanguage();
  const titles = pi_bix_six_translated_titles[key];

  if (!titles) {
    return key.replace(/_/g, ' ');
  }

  const validLanguage = Object.keys(titles.title).includes(language) ? language : 'en';
  return titles.title[validLanguage as keyof TranslationContent] ?? key.replace(/_/g, ' ');
}
